import { useState } from "react";
const tools = [
  { name: "Remove BG", icon: "removeBG" },
  { name: "Recover Image", icon: "recover" },
  { name: "Add Background", icon: "addBG" },
  { name: "Batch Convert", icon: "batch" },
  { name: "AI Concept", icon: "ai" },
];

export default function LayerBar({ image }) {
  const [show,setShow] = useState(true);
  return (
    <>
    <div
      className="relative text-sm w-64 border-r flex flex-col p-2 bg-[#1e1e1e] pt-10"
      style={{ height: "calc(100vh)" }}
    >
      <button
          className="rounded flex items-center w-full mx-auto my-1 px-2 py-1 bg-[#343434]"
          style={{
              opacity: show ? 1 : 0.5,
            }}
        >
          <div className="w-[40px] grid grid-cols-2 gap-2">
            <svg onClick={ () => setShow(!show)} className="w-[20px] mr-auto self-center" fill="#bababa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/><path fill-rule="evenodd" d="M10 4c-2.476 0-4.348 1.23-5.577 2.532a9.266 9.266 0 0 0-1.4 1.922 5.98 5.98 0 0 0-.37.818c-.082.227-.153.488-.153.728s.071.501.152.728c.088.246.213.524.371.818.317.587.784 1.27 1.4 1.922 1.229 1.302 3.1 2.532 5.577 2.532 2.476 0 4.348-1.23 5.577-2.532a9.265 9.265 0 0 0 1.4-1.922 5.98 5.98 0 0 0 .37-.818c.082-.227.153-.488.153-.728s-.071-.501-.152-.728a5.984 5.984 0 0 0-.371-.818 9.269 9.269 0 0 0-1.4-1.922c-1.229-1.302-3.1-2.532-5.577-2.532Zm-5.999 6.002v-.004c.004-.02.017-.09.064-.223a4.5 4.5 0 0 1 .278-.608 7.768 7.768 0 0 1 1.17-1.605c1.042-1.104 2.545-2.062 4.487-2.062 1.942 0 3.445.958 4.486 2.062a7.77 7.77 0 0 1 1.17 1.605c.13.24.221.447.279.608.047.132.06.203.064.223v.004c-.004.02-.017.09-.064.223a4.503 4.503 0 0 1-.278.608 7.768 7.768 0 0 1-1.17 1.605c-1.042 1.104-2.545 2.062-4.487 2.062-1.942 0-3.445-.958-4.486-2.062a7.766 7.766 0 0 1-1.17-1.605 4.5 4.5 0 0 1-.279-.608c-.047-.132-.06-.203-.064-.223Z"/></svg>
            <img className="w-[20px] rounded mr-auto self-center" src={image}/>
          </div>
          <div className="ml-auto text-[#bababa]">Layer 1</div>
      </button>

    </div>


    </>
  );
}
